import React, { type ReactNode } from 'react';

import { createPortal } from 'react-dom';

import { ENV_PRODUCTION } from '@pkg/utils';

import { type PortalArea, type PortalAreaRef, usePortal } from '../PortalProvider';

export interface AbstractPortalProps {
    children: ReactNode;
    destinationRef?: PortalAreaRef;
}

export interface PortalProps {
    children: ReactNode;
    destination?: PortalArea;
}

export function AbstractPortal({ children, destinationRef }: AbstractPortalProps) {
    const fragment = <>{children}</>;
    return destinationRef?.current ? createPortal(fragment, destinationRef.current) : fragment;
}

export function Portal({ children, destination }: PortalProps) {
    const { area } = usePortal();
    const target = destination ? area[destination] : null;

    if (!ENV_PRODUCTION && !target) {
        // eslint-disable-next-line no-console
        console.warn(`<Portal /> - No portal target found for: ${destination}.`);
    }

    return <AbstractPortal destinationRef={target}>{children}</AbstractPortal>;
}
